export default {
    data: function() {
        return {
            mixWindow: {
                width: window.innerWidth,
                height: window.innerHeight,
            },
        }
    },
    computed: {
        mixToggleMDBreakpoint: {
            get: function(){
                return (this.mixWindow.width > 960)
            }
        }
    },
    methods: {
        mixToggleCustomBreakpoint: function(width) {
            return width > this.mixWindow.width
        },
    },
    mounted: function() {
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.mixWindow.height = window.innerHeight
                this.mixWindow.width = window.innerWidth
            })
        })
    },
}
